import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "antd";
import { PlusOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddEnergie from "./AddEnergie";
import ActionDropdown from "../../production/components/ActionDropdown";

const { confirm } = Modal;

const Energies = () => {
  const [energies, setEnergies] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedEnergie, setSelectedEnergie] = useState(null);
  const [loadingEnergies, setLoadingEnergies] = useState(false); // New state for loading energies
  const navigate = useNavigate();

  const fetchEnergies = async () => {
    setLoadingEnergies(true);
    try {
      const res = await axios.get(`${API_URL}/api/convert-energie`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      });
      // Sort by a timestamp or ID if available, otherwise just set
      // Assuming convertEnergieId can be used for sorting to put latest at top initially if needed
      const sortedEnergies = res.data.sort((a, b) => b.convertEnergieId - a.convertEnergieId);
      setEnergies(sortedEnergies);
      setLoadingEnergies(false);
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors du chargement des énergies");
      setLoadingEnergies(false);
    }
  };

  useEffect(() => {
    fetchEnergies();
  }, []);

  const handleShow = (edit, energie = null) => {
    setEditMode(edit);
    setSelectedEnergie(energie);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const showDeleteConfirm = (convertEnergieId) => {
    confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette conversion d'énergie?",
      icon: <ExclamationCircleFilled />,
      content: "Cette action est irréversible.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk() {
        deleteEnergie(convertEnergieId);
      },
    });
  };

  const deleteEnergie = async (convertEnergieId) => {
    try {
      await axios.delete(`${API_URL}/api/convert-energie/${convertEnergieId}`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      });
      setEnergies((prevEnergies) =>
        prevEnergies.filter((en) => en.convertEnergieId !== convertEnergieId)
      );
      toast.success("Conversion d'énergie supprimée avec succès");
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de la suppression");
    }
  };

  // --- Handle Add and Update to keep new/modified at top ---
  const handleAddEnergie = (newEnergie) => {
    setEnergies((prev) => [newEnergie, ...prev]);
  };

  const handleUpdateEnergie = (updatedEnergie) => {
    setEnergies((prev) => {
      const withoutOld = prev.filter(
        (e) => e.convertEnergieId !== updatedEnergie.convertEnergieId
      );
      return [updatedEnergie, ...withoutOld];
    });
  };
  // --- End Handle Add and Update ---

  const columns = [
    {
      title: "Essence",
      dataIndex: "essence",
      key: "essence",
      sorter: (a, b) => a.essence - b.essence, // Enable sorting
    },
    {
      title: "Diesel",
      dataIndex: "diesel",
      key: "diesel",
      sorter: (a, b) => a.diesel - b.diesel, // Enable sorting
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => showDeleteConfirm(record.convertEnergieId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"TARIFICATION"} />

        <div className="layout-page">
          <NavBar />

          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow(false)}
              >
                Ajouter une conversion d'énergie
              </Button>

              <div className="card">
                <Table
                  columns={columns}
                  dataSource={energies}
                  rowKey="convertEnergieId"
                  pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ['5', '10', '20', '50'] }} // Enhanced pagination
                  loading={loadingEnergies} // Show loading state
                />
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>

      <AddEnergie
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        convertEnergieId={selectedEnergie?.convertEnergieId}
        selectedEnergie={selectedEnergie}
        onAdd={handleAddEnergie} 
        onUpdate={handleUpdateEnergie} // Use the new handler
        existingEnergies={energies} // Pass existing energies for duplicate check
      />
    </div>
  );
};

export default Energies;